import { Check, Square } from "@mui/icons-material";
import { formCheckboxIconStyle } from "./styled";
import { genderList, yearsList, monthsList, daysList } from "./define";

export const formValidate = (values, props) => {
  const errors = {};
  const emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

  if (!values.firstName) {
    errors.firstName = formState.firstName.warning;
  }
  if (!values.lastName) {
    errors.lastName = formState.lastName.warning;
  }
  if (!values.gender) {
    errors.gender = formState.gender.warning;
  }
  if (!values.birthdayDay || !values.birthdayYear || !values.birthdayMonth) {
    errors.birthday = formState.birthday.warning;
  }

  if (!values.phone) {
    errors.phone = formState.phone.warning;
  } else if (!values.phone.match(/^(09)[0-9]{8}$/)) {
    errors.phone = formState.phone.format_warning;
  }
  if (props.profile.phone !== values.phone) {
    if (!props.getCode) {
      errors.verifySms = formState.verifySms.verify_warning;
    }
  }

  if (props.getCode && !values.verifySms) {
    errors.verifySms = formState.verifySms.warning;
  }
  // if (!values.email) {
  //   errors.email = "此為必填";
  // }
  if (values.email && !values.email.match(emailFormat)) {
    if (values.email.replaceAll(" ", "") !== values.email) {
      errors.email = formState.email.format_warning;
    } else {
      errors.email = formState.email.warning;
    }
  }
  if (!values.store) {
    errors.store = formState.store.warning;
  }

  if (!values.privacy) {
    errors.privacy = formState.privacy.warning;
  }

  return errors;
};

export const formState = {
  lastName: {
    name: "lastName",
    label: "姓氏",
    required: true,
    type: "input",
    warning: "* 姓氏未填寫",
  },
  firstName: {
    name: "firstName",
    label: "名字",
    required: true,
    type: "input",
    warning: "* 名字未填寫",
  },
  gender: {
    name: "gender",
    label: "",
    required: true,
    type: "radio",
    options: genderList,
    warning: "* 稱謂未勾選",
    checkedIcon: <Check />,
    iconStyle: formCheckboxIconStyle,
    icon: <Square />,
  },
  // the key of birthday is only for view modal
  birthday: {
    name: "birthday",
    label: "生日",
    warning: "* 生日未填寫",
  },
  birthdayYear: {
    name: "birthdayYear",
    label: "生日",
    required: true,
    type: "select",
    options: yearsList(),
  },
  birthdayMonth: {
    name: "birthdayMonth",
    label: "生日",
    required: true,
    type: "select",
    options: monthsList,
  },
  birthdayDay: {
    name: "birthdayDay",
    label: "生日",
    required: true,
    type: "select",
    options: daysList(),
  },
  phone: {
    name: "phone",
    label: "電話",
    required: true,
    type: "input",
    inputProps: { inputMode: "numeric", pattern: "[0-9]*" },
    placeholder: "請輸入您的手機號碼",
    warning: "* 電話未填寫",
    format_warning: "* 電話格式有誤，應為09XXXXXXXX，請勿輸入空格",
  },
  verifySms: {
    name: "verifySms",
    label: "手機驗證碼",
    required: true,
    type: "input",
    inputProps: { inputMode: "numeric", pattern: "[0-9]*" },
    placeholder: "請輸入手機驗證碼",
    verify_warning: "* 手機號碼未驗證",
    warning: "* 手機驗證碼未填寫",
  },
  email: {
    name: "email",
    label: "Email",
    required: false,
    type: "input",
    placeholder: "請輸入Email信箱地址",
    warning: "* 選填項目 - Email格式有誤",
    format_warning: "* 選填項目 - Email格式有誤，請勿輸入空格",
  },
  store: {
    name: "store",
    label: "櫃點",
    required: true,
    type: "select",
    warning: "* 櫃點未填寫",
  },
  privacy: {
    name: "privacy",
    label: "",
    type: "check",
    required: true,
    warning: "* 隱私權未同意",
  },
};
